<template>
  <div class="notFound container my-88">
    <div class="flex items-center">
      <div class="flex items-center justify-center">
        <img class="inline-block" style="width: 82px;" src="~@/assets/images/no-data.svg" alt="">
      </div>
      <div class="pl-40">
        <h1 class="font-bold text-grey-darkest mb-4">{{ $t('searchData') }}</h1>
        <p class="text-lg text-grey-darker mb-8">{{ $t('tryToFindOtherLocation') }}</p>
        <!-- <p class="text-md text-grey-dark mb-24">Error code: 404</p> -->
        <!-- <router-link :to="{name: 'Home'}" class="btn btn-text btn-blue pl-0 no-underline">{{ $t('backToHome') }}</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  metaInfo () {
    return {
      title: ''
    }
  }
}
</script>

<style lang="sass" scoped>
.notFound
  @apply flex items-center justify-center
</style>
